<template>
    <div class="line"
         v-if="pageAsk.type == 4">
        <!-- 小题内容开始 -->
        <!--<span class="title" v-if="!pageAsk.content">{{pageAsk.no}}</span>-->
        <div :class="{'tit_top':!pageAsk.content&&checked}">
            <div :class="[Number(number)||Number(number)===0?'askTitle padding':'askTitle']"
                 v-if="!tag">
                <p v-html="pageAsk.content"
                   v-if="pageAsk.content"></p>
                <!-- <p v-html="pageAsk.parse" v-if="pageAsk.parse"></p> -->
                <span class="tit_num"
                      v-if="Number(number)">{{number}}、</span>
                <span class="tit_num"
                      v-else-if="Number(number)===0">{{ask.no}}、</span>
            </div>
        </div>
        <div :class="[tag?'line-wrap clearfix borTop':'line-wrap clearfix']" 
             :id="'canvasWrap'+pageAsk.id+pageTag">
            <canvas :id="'canvas'+pageAsk.id+pageTag"></canvas>
            <div class="line-left">
                <template v-for="option in pageAsk.options">
                    <div :class="['line-option',{'origin':origin},{'inspect_myColor':myColor}]"
                         v-if='option.link_id == -1'
                         :id="'optionLeft'+option.id+pageTag"
                         @click="chooseLeft(pageAsk.id,option.id)">
                        <!-- <span v-html="option.content">{{option.id}}</span> -->
                        <span v-if="option.content">{{option.content}}</span>
                        <img v-if="option.image"
                             :src="option.image"
                             alt="">
                    </div>
                </template>
            </div>
            <div class="line-right"
                 :id="'right'+ pageAsk.id">
                <template v-for="option in pageAsk.options">
                    <div :class="['line-option','optionRight',{'origin':origin},{'inspect_myColor':myColor}]"
                         v-if='option.link_id != -1'
                         @click="chooseRight(pageAsk.id,option.id)"
                         :id="'optionRight'+option.id+pageTag">
                        <span v-if="option.content">{{option.content}}</span>
                        <img v-if="option.image"
                             :src="option.image"
                             alt="">
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    data () {
        return {
            onlyShowAnswer: false,
        }
    },
    // 父组件通过ask字段 传给子组件当前题目的数据
    // sheet是用户答案
    // onlyshow 是否可操作
    // tag 每个连线实体的标记，为结果展示同ID试题做的标记
    //origin 原点的颜色 1 #cccccc 0 #6c2
    computed: {
        pageAsk () {
            return this.ask
        },
        pageTag () {
            return this.tag ? this.tag : ''
        },
        lineColor () {
            if (this.myColor) {
                return '#5d89ef';
            } else {
                return (this.result == 0 ? '#cccccc' : 'hsl(120,50%,50%)');
            }
        }
    },
    props: ['ask', 'sheet', 'onlyshow', 'tag', 'result', 'number', 'origin', 'checked', 'myColor'],
    watch: {
        // 检测到ask变化，那就重绘整个页面
        ask () {
            this.$nextTick(function () {
                this.initData()
                this.initCanvas()
            })
        },
        tag () {
            this.$nextTick(function () {
                this.initData()
                this.initCanvas()
            })
        }
    },
    methods: {
        chooseRight (askId, id) {
            if (this.onlyShowAnswer) return false;
            // 获取选项的当前dom
            let target = document.getElementById('optionRight' + id + this.pageTag);
            if (!target) return false;
            let canvasObject = this.pageAsk.canvas;
            canvasObject.right = { target, id }
            if (canvasObject.right && canvasObject.left) {
                // //console.log(canvasObject.right)
                this.makeObject(askId);
            }
        },
        chooseLeft (askId, id) {
            if (this.onlyShowAnswer) return false;
            // 获取选项的当前dom
            let target = document.getElementById('optionLeft' + id + this.pageTag);
            if (!target) return false;
            let canvasObject = this.pageAsk.canvas;
            // //console.log(canvasObject)
            canvasObject.left = { target, id };
            // //console.log(canvasObject.left)
            if (canvasObject.right && canvasObject.left) {
                this.makeObject(askId);
            }
        },
        makeObject (askId) {
            let canvasObject = this.pageAsk.canvas;
            let _o = {};//左侧和右侧dom节点的x,y坐标
            let to = canvasObject.right.id//右侧的索引值
            // //console.log(canvasObject.right.id,canvasObject.left.id)
            _o[canvasObject.left.id] = { ...this.getLeftPos(canvasObject.left.target), ...this.getRightPos(canvasObject.right.target), ...{ to } }
            canvasObject.lineId = { ...canvasObject.lineId, ..._o }
            canvasObject.left = null;
            canvasObject.right = null;
            this.drawCanvas(askId);
        },
        drawCanvas (askId) {
            let canvasObject = this.pageAsk.canvas.lineId;
            // //console.log(canvasObject)
            let myCanvas = document.getElementById('canvas' + askId + this.pageTag)
            let context = myCanvas.getContext("2d");
            myCanvas.width = myCanvas.width
            context.strokeStyle = this.lineColor;//线颜色
            context.lineWidth = 2;//设置线宽
            let resultArray = [];
            // //console.log(canvasObject)
            for (let key in canvasObject) {
                let obj = canvasObject[key];
                context.moveTo(obj.x, obj.y);
                context.lineTo(obj.lx, obj.ly);
                resultArray.push(`${key}-${obj.to}`);
            }
            context.stroke();//画线框
            let _o = {
                askid: askId,
                result: resultArray.join('|'),
                askindex: this.pageAsk.no
            }
            if (!this.onlyshow) this.$emit('myResult', _o);
        },
        getLeftPos (target) {
            // 当前元素对应的绿点的坐标
            return {
                lx: target.offsetLeft + target.clientWidth,
                ly: target.offsetTop + target.clientHeight / 2
            }
        },
        getRightPos (target) {
            // 当前元素对应的绿点的坐标
            return {
                x: target.offsetLeft + target.parentNode.clientWidth,
                y: target.offsetTop + target.clientHeight / 2
            }
        },
        initData () {
            // 给每个小问添加原始数据
            this.pageAsk.canvas = {
                left: null,
                right: null,
                lineId: {}
            }
            // this.pageAsk.equal = this.leftEqRight();
        },
        initCanvas () {
            // 初始化canvas，将canvas设置为和父元素一样宽高
            let canvas = document.getElementById('canvas' + this.pageAsk.id + this.pageTag);
            let wrapDiv = document.getElementById('canvasWrap' + this.pageAsk.id + this.pageTag)
            canvas.setAttribute('height', wrapDiv.clientHeight)
            canvas.setAttribute('width', wrapDiv.clientWidth)
            this.pageAsk.height = wrapDiv.clientHeight
            this.pageAsk.width = wrapDiv.clientWidth
            this.pageAsk.canvas.lineId = [];

            // 初始化sheet（答案）表，将用户答案渲染上去
            // //console.log(this.sheet)
            if (this.sheet) {
                // //console.log(this.sheet)
                // let answer = this.sheet[0].split('|');
                let answer
                if (typeof this.sheet == "string") {
                    answer = this.sheet.split('|');
                } else {
                    answer = this.sheet[0].split('|');
                }
                let askId = this.pageAsk.id;
                // if(typeof this.sheet == "string"){
                // 	answer=this.sheet.split('|');
                // }
                answer.forEach((option) => {
                    let _option = option.split('-');
                    this.chooseLeft(askId, _option[0]);
                    this.chooseRight(askId, _option[1]);
                })
            }
            // 如果是展示页面 在展示完后，加锁让所有不能点击
            this.onlyShowAnswer = this.onlyshow;
        }
    },
    mounted () {
        this.initCanvas()
    },
    created () {
        let _this = this;
        this.initData();
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

.line {
    position: relative;
    z-index: 1;
    .askTitle {
        p {
            padding: 35px / $ppr 24px / $ppr;
            border-top: 1px / $ppr solid #e8e8e8;
            &:first-child {
                border-top: none;
            }
        }
        &.padding {
            position: relative;
            p:first-child {
                padding-left: 80px / $ppr;
            }
            .tit_num {
                position: absolute;
                top: 35px / $ppr;
                left: 24px / $ppr;
            }
        }
    }
    .tit_top {
        min-height: 100px / $ppr;
    }
}

.line-wrap {
    padding: 35px / $ppr 0;
    position: relative;
    z-index: 1;
    border-top: 1px / $ppr solid #e8e8e8;
    &.borTop {
        border-top: none;
    }
    canvas {
        position: absolute;
        left: 0;
        top: 35px / $ppr;
        z-index: 1;
    }
    .line-left,
    .line-right {
        width: 50%;
        position: relative;
        z-index: 2;
        img {
            max-width: 168px / $ppr;
            max-height: 128px / $ppr;
            display: block;
            margin: 0 auto;
        }
    }
    .line-option {
        width: 200px / $ppr;
        height: 200px / $ppr;
        background-color: #fff;
        text-align: center;
        word-wrap: break-word;
        word-break: break-word;
        position: relative;
        z-index: 1;
        border-radius: 16px / $ppr;
        border: 1px / $ppr solid #ccc;
        display: inline-block;
        vertical-align: top;
        margin-bottom: 24px / $ppr;
        font-size: 26px / $ppr;
        &:after {
            content: "";
            height: 24px / $ppr;
            width: 24px / $ppr;
            border-radius: 50%;
            background-color: #6c2;
            position: absolute;
            top: 50%;
            margin-top: -12px / $ppr;
        }
        .inspect_myColor {
            &:after {
                content: "";
                height: 24px / $ppr;
                width: 24px / $ppr;
                border-radius: 50%;
                background-color: #5d89ef;
                position: absolute;
                top: 50%;
                margin-top: -12px / $ppr;
            }
        }
        span {
            display: block;
            width: 200px / $ppr;
            height: 200px / $ppr;
            line-height: 40px / $ppr;
            font-size: 26px / $ppr;
            // overflow-x: auto;
            overflow-y: scroll;
        }
    }
    .origin {
        &:after {
            content: "";
            height: 24px / $ppr;
            width: 24px / $ppr;
            border-radius: 50%;
            background-color: #cccccc;
            position: absolute;
            top: 50%;
            margin-top: -12px / $ppr;
        }
    }
    .inspect_myColor {
        &:after {
            content: "";
            height: 24px / $ppr;
            width: 24px / $ppr;
            border-radius: 50%;
            background-color: #5d89ef;
            position: absolute;
            top: 50%;
            margin-top: -12px / $ppr;
        }
    }
    .line-left {
        float: left;
        text-align: left;
        .line-option {
            margin-left: 60px / $ppr;
            &:after {
                right: -12px / $ppr;
            }
        }
    }
    .line-right {
        float: right;
        text-align: right;
        .line-option {
            margin-right: 60px / $ppr;
            &:after {
                left: -12px / $ppr;
            }
        }
    }
}
</style>
